import { useEffect, useState } from 'react'
import { api, ErroreApi } from '../servizi/api.ts'
import { nomeDispositivo } from '../servizi/accesso-ricordato.ts'
import { useSessione } from '../servizi/sessione.tsx'
import { Avviso } from './Pezzi.tsx'
import { Bottone, Riquadro } from './base.tsx'

/**
 * «Telefoni connessi» in «Il mio profilo» (521): i telefoni che entrano senza password, l'app Android e
 * la web app dell'iPhone con Face ID. «Scollega» li revoca, con le sessioni aperte da loro. Il riquadro
 * compare solo se ce n'e' almeno uno. I computer ricordati (531) hanno il riquadro loro, ComputerRicordati.tsx.
 */

export type Dispositivo = {
  id: string; tipo: 'app' | 'schermata_home' | 'computer'; etichetta: string | null
  creato_il: string; usato_il: string | null; scade_il: string; questo: boolean
}
type Telefono = Dispositivo

export const giorno = (v: string) => new Date(v).toLocaleDateString('it-IT')

export function TelefoniConnessi() {
  const { aggiorna } = useSessione()
  const [telefoni, setTelefoni] = useState<Telefono[]>([])
  const [errore, setErrore] = useState<string | null>(null)
  const [inCorso, setInCorso] = useState<string | null>(null)

  const carica = () => api.get<Telefono[]>('/auth/telefoni').then((t) => setTelefoni(t.filter((x) => x.tipo !== 'computer')))
  useEffect(() => { carica().catch(() => setTelefoni([])) }, [])

  async function scollega(t: Telefono) {
    setErrore(null); setInCorso(t.id)
    try {
      await api.post(`/auth/telefoni/${t.id}/revoca`)
      // Scollegando il telefono in mano si chiude anche questa sessione.
      if (t.questo) await aggiorna()
      else await carica()
    } catch (e) {
      setErrore(e instanceof ErroreApi ? e.message : 'Non è andata: riprova.')
    } finally {
      setInCorso(null)
    }
  }

  if (!telefoni.length) return null
  return (
    <Riquadro titolo="Telefoni connessi">
      <p className="piccolo tenue">
        Entrano senza password per 30 giorni dall’ultimo uso: l’app Android con lo sblocco del telefono, l’iPhone con
        Face ID. Se perdi un telefono, scollegalo da qui.
      </p>
      {errore && <Avviso tipo="errore">{errore}</Avviso>}
      <ul className="telefoni-connessi">
        {telefoni.map((t) => (
          <li key={t.id}>
            <div>
              <strong>{t.tipo === 'app' ? 'App CIDIS per Android' : 'iPhone, dalla schermata Home'}</strong>
              {t.questo && <span className="piccolo tenue"> · questo telefono</span>}
              <div className="piccolo tenue">
                {nomeDispositivo(t.etichetta) ? `${nomeDispositivo(t.etichetta)} · ` : ''}dal {giorno(t.creato_il)}
                {t.usato_il ? `, usato il ${giorno(t.usato_il)}` : ''}, vale fino al {giorno(t.scade_il)}
              </div>
            </div>
            <Bottone variante="secondario" dimensione="piccolo" inCorso={inCorso === t.id}
                     onClick={() => { void scollega(t) }}>
              Scollega
            </Bottone>
          </li>
        ))}
      </ul>
    </Riquadro>
  )
}
